export default {
  groups: [],
  group: {},
};
